<template>
    <div class="top-ctas noselect">
        <div class="strips">
            <div class="strip follow" @click = "toggleFollow" ref = "follow">
                <div class="follow2" >
                    <div class="follow-states follow-off">
                        <div class="txt">
                            <span>FOLLOW</span>
                        </div>
                        <div class="icon">
                            <ArrowRight/>
                        </div>
                    </div>
                    <div class="follow-states follow-on">
                        <div class="follow-on2">
                            <div class="icon on">
                                <ArrowRight/>
                            </div>
                            <a v-for="(item, index) in this.socialMedia" :key="`ctasocicon-${index}`" :title="item.title" :href="item.link" target="_blank">
                                <span :class="`socicon socicon-${item.sociconId}`" v-if="item.sociconId == 'tiktok'">
                                    <svg fill="#fff" width="26px" height="26px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xml:space="preserve"><path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.526V6.79a4.831 4.831 0 0 1-1.003-.104z"/></svg>
                                </span>
                                <span :class="`socicon socicon-${item.sociconId}`" v-else-if="item.sociconId == 'bluesky'">
                                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 26" fill = "#fff">
                                        <path d="M5.6,3.1c3,2.2,6.2,6.8,7.4,9.2,1.2-2.4,4.4-7,7.4-9.2,2.2-1.6,5.6-2.9,5.6,1.1s-.5,6.7-.7,7.6c-.9,3.3-4.3,4.2-7.3,3.7,5.3.9,6.6,3.9,3.7,6.8-5.5,5.6-7.9-1.4-8.5-3.2-.1-.3-.2-.5-.2-.4,0-.1,0,0-.2.4-.6,1.8-3,8.8-8.5,3.2-2.9-3-1.6-5.9,3.7-6.8-3,.5-6.4-.3-7.3-3.7C.5,10.9,0,5,0,4.2,0,.2,3.5,1.5,5.6,3.1h0Z"/>
                                    </svg>
                                </span>
                                <span :class="`socicon socicon-${item.sociconId}`" v-else-if="item.sociconId == 'threads'">
                                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 26" fill = "#fff">
                                        <path d="M18.8,12.1c-.1,0-.2-.1-.3-.2-.2-3.7-2.2-5.8-5.6-5.8,0,0,0,0,0,0-2,0-3.7.9-4.7,2.4l1.9,1.3c.8-1.2,2-1.4,2.9-1.4s0,0,0,0c1.1,0,1.9.3,2.5,1,.4.5.7,1.1.8,1.9-1-.2-2-.2-3.2-.2-3.2.2-5.3,2.1-5.1,4.6,0,1.3.7,2.4,1.8,3.2.9.6,2.2.9,3.4.9,1.7,0,3-.7,3.9-1.9.7-.9,1.1-2,1.3-3.5.8.5,1.4,1.1,1.7,1.9.6,1.3.6,3.4-1.1,5.2-1.5,1.5-3.4,2.2-6.1,2.2-3.1,0-5.4-1-6.9-2.9-1.4-1.8-2.1-4.4-2.2-7.7,0-3.3.8-5.9,2.2-7.7,1.5-1.9,3.8-2.9,6.9-2.9,3.1,0,5.4,1,7,2.9.8.9,1.3,2.1,1.7,3.5l2.2-.6c-.5-1.7-1.2-3.2-2.2-4.4C19.5,1.4,16.6.1,12.8,0h0c-3.8,0-6.7,1.3-8.6,3.8-1.7,2.2-2.6,5.3-2.7,9.1h0s0,0,0,0c0,3.8.9,6.9,2.7,9.1,1.9,2.5,4.9,3.7,8.6,3.8h0c3.4,0,5.7-.9,7.7-2.8,2.5-2.5,2.5-5.7,1.6-7.7-.6-1.4-1.8-2.5-3.3-3.3ZM13,17.5c-1.4,0-2.9-.6-2.9-1.9,0-1,.7-2.1,3-2.2.3,0,.5,0,.8,0,.8,0,1.6,0,2.3.2-.3,3.3-1.8,3.9-3.2,3.9Z"/>
                                    </svg>
                                </span>
                                <span :class="`socicon socicon-${item.sociconId}`" v-else-if="item.sociconId == 'twitter'">
                                    <svg width="1200" height="1227" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
                                    </svg>
                                </span>
                                <span v-else :class="`socicon socicon-${item.sociconId}`"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="strip theme" ref="theme" @click="toggleTheme">
                <div class="icon">
                    <IconTheme/>
                </div>
                <div class="txt">
                    <span>THEME</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gh from '@/helpers/gh'
import ArrowRight from "@/components/svgs/ArrowRight";
import IconTheme from "@/components/svgs/IconTheme.vue";
export default {
    name: "TopCTAs",
    components: {
        IconTheme,
        ArrowRight
    },
    data() {
        return {
            window:window,
            document:document,
            socialMedia:[]
        }
    },
    mounted() {
        this.socialMedia = this.window.config.json.global.socialMedia
    },
    methods: {
        gotoFollow() {
            //gh.scrollTo('#follow-hook', window)
        },
        toggleTheme() {
            gh.toggleTheme(this.document)
        },
        toggleFollow(e) {
            if (e.target.closest('a')) {
                return;
            }
            this.$refs.follow.classList.toggle('active');
        }
    }
}
</script>
